module.exports = __webpack_public_path__ + "static/media/upload-file.84b81bb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upload-file.svg
// module id = 1955
// module chunks = 1